import { importAll } from 'utils/helperFunctions';

export const leftMenuIcons = importAll(
  require.context('../../assets/leftMenuIcons', false, /\.(png|jpe?g|svg)$/),
);
